import { ConfigProps } from "@~/configValidation/configSchema";
import { SkeletonProduct } from "../../types/types";
import styles from "./LoaderComponent.module.scss";

type LoaderComponentProps = {
  configProps?: ConfigProps;
  index: number;
  product: SkeletonProduct;
};

type LoaderComponent = (props: LoaderComponentProps) => React.ReactNode;

const StandardLoaderComponent = ({
  componentName,
}: LoaderComponentProps & { componentName: string }) => {
  {
    return (
      <div
        className={`${styles.loader} ${styles[`loader--${componentName}`]}`}
        data-testid={`loader-${componentName}`}
      ></div>
    );
  }
};

const TitleLoaderComponent = () => {
  return (
    <div>
      <div
        className={`${styles.loader} ${styles[`loader--Title-brand`]}`}
        data-testid={`loader-Title`}
      ></div>
      <div
        className={`${styles.loader} ${styles[`loader--Title-product`]}`}
        data-testid={`loader-Title`}
      ></div>
    </div>
  );
};

export const componentMap: { [name: string]: LoaderComponent } = {
  CallToAction: (props: LoaderComponentProps) => (
    <StandardLoaderComponent componentName="CallToAction" {...props} />
  ),
  Price: (props: LoaderComponentProps) => (
    <StandardLoaderComponent componentName="Price" {...props} />
  ),
  ImageList: (props: LoaderComponentProps) => (
    <StandardLoaderComponent componentName="ImageList" {...props} />
  ),
  StaticImage: (props: LoaderComponentProps) => (
    <StandardLoaderComponent componentName="StaticImage" {...props} />
  ),
  Title: TitleLoaderComponent,
};
